import React from 'react';
import { Check, ArrowRight } from 'lucide-react';

const plans = [
  {
    name: 'Starter',
    price: 'Free',
    period: '',
    description: 'Perfect for individual agents getting started',
    features: ['Up to 5 active listings', 'AI description generation', 'Basic market analysis', 'Lead capture forms', 'Draft saving'],
    cta: 'Get Started Free',
    highlight: false,
    color: '#6B9EC4'
  },
  {
    name: 'Professional',
    price: '$49',
    period: '/month',
    description: 'For active agents managing multiple listings',
    features: ['Unlimited listings', 'Advanced AI copy & SEO', 'Full market analysis', 'Bulk upload (up to 50)', 'Priority portal publishing', 'Analytics dashboard', 'Draft saving & collaboration'],
    cta: 'Start Free Trial',
    highlight: true,
    color: '#00D4FF'
  },
  {
    name: 'Agency',
    price: '$199',
    period: '/month',
    description: 'For agencies and large portfolio managers',
    features: ['Everything in Professional', 'Unlimited bulk upload', 'Team management', 'White-label options', 'API access', 'Dedicated account manager', 'Custom integrations'],
    cta: 'Contact Sales',
    highlight: false,
    color: '#7B2FFF'
  }
];

const PricingSection = ({ onStartListing }) => {
  return (
    <section className="py-20 px-4" id="pricing" style={{ background: 'rgba(0, 212, 255, 0.02)' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8F4FD' }}>Simple, Transparent Pricing</h2>
          <p className="text-base" style={{ color: '#6B9EC4' }}>No hidden fees. Cancel anytime.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {plans?.map((plan, i) => (
            <div
              key={i}
              className="p-7 rounded-2xl flex flex-col relative"
              style={{
                background: plan?.highlight ? 'rgba(0, 212, 255, 0.08)' : 'rgba(5, 10, 20, 0.8)',
                border: plan?.highlight ? '1px solid rgba(0, 212, 255, 0.4)' : `1px solid ${plan?.color}25`,
                boxShadow: plan?.highlight ? '0 0 40px rgba(0, 212, 255, 0.15)' : 'none'
              }}
            >
              {plan?.highlight && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full text-xs font-bold" style={{
                  background: 'linear-gradient(135deg, #00D4FF, #7B2FFF)',
                  color: '#fff'
                }}>
                  Most Popular
                </div>
              )}

              <div className="mb-6">
                <h3 className="text-lg font-bold mb-1" style={{ color: '#E8F4FD' }}>{plan?.name}</h3>
                <p className="text-xs mb-4" style={{ color: '#4A7A9B' }}>{plan?.description}</p>
                <div className="flex items-baseline gap-1">
                  <span className="text-4xl font-bold" style={{ color: plan?.color }}>{plan?.price}</span>
                  {plan?.period && <span className="text-sm" style={{ color: '#4A7A9B' }}>{plan?.period}</span>}
                </div>
              </div>

              <ul className="space-y-3 mb-8 flex-1">
                {plan?.features?.map((f, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm" style={{ color: '#A0C4D8' }}>
                    <Check size={15} color={plan?.color} className="flex-shrink-0 mt-0.5" />
                    {f}
                  </li>
                ))}
              </ul>

              <button
                onClick={onStartListing}
                className="flex items-center justify-center gap-2 w-full py-3 rounded-xl text-sm font-semibold transition-all"
                style={{
                  background: plan?.highlight ? 'linear-gradient(135deg, #00D4FF, #7B2FFF)' : `${plan?.color}20`,
                  color: plan?.highlight ? '#fff' : plan?.color,
                  border: plan?.highlight ? 'none' : `1px solid ${plan?.color}40`,
                  boxShadow: plan?.highlight ? '0 0 20px rgba(0,212,255,0.3)' : 'none'
                }}
              >
                {plan?.cta}
                <ArrowRight size={15} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
